import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  customTool: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginTop: '10px'
  },
  disableImportLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      '& .makeStyles-dialogTitle-38': {
        padding: '16px 12px !important',
      },
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  disableIcon: {
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  importLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
  },
  dialogMinWidth: {
    maxWidth: '700px',
  },
  dialogMaxWidth: {
    maxWidth: '1150px',
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  },
  inputField: {
    width: '100%'
  },
  targetContainer: {
    marginBottom: '20px',
    border: '2px solid grey',
    margin: '12px',
    position: 'relative'
  },
  entryLabel: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '10px'
  },
  gridContainer: {
    paddingTop: '4px',
    borderBottom: '1px solid #ccc'
  },
  gridItem: {
    background: '#F2F2F2',
    paddingBottom: '1px',
    borderBottom: '0.5px solid #FFF',
    textAlign: 'center'
  },
  headerName: {
    flex: 0.5,
    fontWeight: 'bold',
    borderRight: '1px solid #ccc',
    textAlign: 'center'
  }
}));
export default styles;
